"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseErrorUtils = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeErrorConstants_1 = require("./TradeErrorConstants");
const supportParseErrorOrders = [
    TradeAPILib_1.ExchangeOrderType.gridLoan,
    TradeAPILib_1.ExchangeOrderType.gridShort,
    TradeAPILib_1.ExchangeOrderType.gridPro,
    TradeAPILib_1.ExchangeOrderType.gridV3,
    TradeAPILib_1.ExchangeOrderType.gridV4,
    TradeAPILib_1.ExchangeOrderType.gridV5,
    TradeAPILib_1.ExchangeOrderType.gridV4Futures,
    TradeAPILib_1.ExchangeOrderType.gridClassic,
    TradeAPILib_1.ExchangeOrderType.gridLeverage,
    TradeAPILib_1.ExchangeOrderType.gridLeverageShort,
    TradeAPILib_1.ExchangeOrderType.gridFuture,
    TradeAPILib_1.ExchangeOrderType.smartTrade,
    TradeAPILib_1.ExchangeOrderType.fsa,
    TradeAPILib_1.ExchangeOrderType.SR,
    TradeAPILib_1.ExchangeOrderType.martingale,
    TradeAPILib_1.ExchangeOrderType.ig,
    TradeAPILib_1.ExchangeOrderType.twap,
    TradeAPILib_1.ExchangeOrderType.aip,
    TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
    TradeAPILib_1.ExchangeOrderType.copy_bot,
];
exports.ParseErrorUtils = {
    formatterToString(error) {
        let errorMessage = "error is undefined";
        if (typeof error === "string") {
            errorMessage = error;
        }
        else if (typeof error === "object") {
            if (error.code && error.message) {
                const formatterError = (0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error);
                errorMessage = `Message: ${formatterError.message}\nCode: ${formatterError.code}`;
            }
            else if (error.message) {
                errorMessage = error.message;
            }
            else {
                errorMessage = JSON.stringify(error);
            }
        }
        else if (error) {
            errorMessage = `${error}`;
        }
        return errorMessage;
    },
    parseTradeError(error, $st) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (!error.code) {
            return this.formatterToString(error);
        }
        let localizedError = "";
        switch (error.code) {
            case -33:
                localizedError = TradeErrorConstants_1.TradeErrorConstants.gridHasPending($st);
                break;
            case -34:
                localizedError = TradeErrorConstants_1.TradeErrorConstants.gridTooManyMicroOrder($st);
                break;
            case -36:
                localizedError = TradeErrorConstants_1.TradeErrorConstants.gridTooManyRow($st);
                break;
            case -37:
                localizedError = TradeErrorConstants_1.TradeErrorConstants.gridTooManyOneKey($st);
                break;
            case -44:
                localizedError = TradeErrorConstants_1.TradeErrorConstants.gridFutureHasSameSymbolOpeningOrder($st);
                break;
            case -45:
                localizedError = $st("gird_orders_count_no_more_than_two");
                break;
            case -47:
                localizedError = $st("trade_error_bot_order_can_not_more", {
                    max: 30,
                });
                break;
            case -48:
                const invalidStr = "leveraged coin investment exceed ";
                const message = `${error.message}`;
                const max = message.substring(invalidStr.length);
                localizedError = $st("trade_error_symbol_invest_high", { max: max });
                break;
            case -49:
            case -50004:
            case -50:
            case -50005:
                const dataBase = ((_a = error.data) === null || _a === void 0 ? void 0 : _a.base)
                    ? TradeAPILib_1.TradeUtils.parseDisplay(error.data.base, "", TradeAPILib_1.ExchangeID.PIONEXV2).baseDisplay
                    : undefined;
                const dataQuote = ((_b = error.data) === null || _b === void 0 ? void 0 : _b.quote)
                    ? TradeAPILib_1.TradeUtils.parseDisplay(error.data.quote, "", TradeAPILib_1.ExchangeID.PIONEXV2).baseDisplay
                    : undefined;
                const _base = dataBase !== null && dataBase !== void 0 ? dataBase : "--";
                const _quote = dataQuote !== null && dataQuote !== void 0 ? dataQuote : "--";
                localizedError = $st("bot_error_50", {
                    symbol: `${_base}/${_quote}`,
                });
                break;
            case -53:
                localizedError = $st("trade_loan_exceed_max_loan", {
                    max: "1,000,000 USDT",
                });
                break;
            case -54:
                localizedError = $st("trade_loan_exceed_max_margin_percent", {
                    max: "50%",
                });
                break;
            case -55:
                localizedError = $st("trade_loan_exceed_max_loan_on_3x", {
                    max: "100,000 USDT",
                });
                break;
            case -100:
                localizedError = $st("symbol_not_support_trading");
                break;
            case -50002:
                localizedError = $st("bot_error_opening_in_this_pair");
                break;
            case -50003:
                localizedError = $st("fsa_error_had_order_already");
                break;
            case -50010:
                localizedError = $st("bot_error_robots_limit_exceeded", {
                    limit: (_d = (_c = error.data) === null || _c === void 0 ? void 0 : _c.order_count_limit) !== null && _d !== void 0 ? _d : "--",
                });
                break;
            case -60002:
                localizedError = $st("trade_error_fsa_max_limit", {
                    max: "50000 USDT",
                });
                break;
            case -60003:
                const reason = ((_e = error.data) === null || _e === void 0 ? void 0 : _e.reason) || ""; // 超额原因
                const investment = ((_f = error.data) === null || _f === void 0 ? void 0 : _f.max_investment) || "100000"; // 基于该超额范围的允许投资额度
                // const remain = error.data?.remain || ""; // 基于该超额范围的剩余可用投资额
                switch (reason) {
                    //   case "total_investment":
                    //   case "total_investment_with_extra_quota":
                    //     break;
                    case "total_investment_alt_coin":
                    case "total_investment_alt_coin_with_extra_quota":
                        localizedError = $st("trade_error_fsa_total_investment_alt_coin", {
                            max: investment,
                        });
                        break;
                    case "single_coin_investment_alt_coin":
                    case "single_coin_investment_alt_coin_with_extra_quota":
                        localizedError = $st("trade_error_fsa_single_coin_investment_alt_coin", { max: investment });
                        break;
                    case "total_investment_whole_net":
                        localizedError = $st("trade_error_fsa_total_investment_whole_net");
                        break;
                    default:
                        localizedError = $st("trade_error_fsa_max_limit", {
                            max: investment + " USDT",
                        });
                }
                break;
            case -60004:
                if (error && error.data && error.data.max_investment && error.data.currency) {
                    localizedError = $st("trade_error_market_spending_more", {
                        limit: `${error.data.max_investment} ${error.data.currency}`,
                    });
                }
                break;
            case -60005:
                if (error && error.data && error.data.max_investment && error.data.currency && error.data.coin) {
                    localizedError = $st("trade_error_fsa_max_limit_for_single_coin", {
                        coin: error.data.coin,
                        value: error.data.max_investment,
                        quote: error.data.currency,
                    });
                }
                break;
            case -60006:
                if (error && error.data && error.data.quote_total_investment_max) {
                    const max = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(error.data.quote_total_investment_max, 8);
                    localizedError = $st("trade_error_investment_limit_exceeded", {
                        max: max,
                    });
                }
                break;
            case -60007:
                localizedError = $st("martingale_error_stop_price_upper_need_more_than_lower");
                break;
            case -60008:
                localizedError = $st("trade_error_exchange_order_limit_exceeded");
                break;
            case -60012:
                const limit = (_g = error.data) === null || _g === void 0 ? void 0 : _g.quote_total_investment_max;
                localizedError = $st("trade_error_bot_type_symbol_investment_exceeded", {
                    limit: limit ? Number(limit) : "--",
                });
                break;
            case -60013:
                localizedError = $st("martingale_error_action_not_in_range");
                break;
            case -60014:
                if ((_h = error === null || error === void 0 ? void 0 : error.data) === null || _h === void 0 ? void 0 : _h.limit) {
                    const max = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(error.data.limit, 8);
                    localizedError = $st("bot_error_smart_copy_total_limit_exceeded", {
                        max: max,
                    });
                }
                break;
            case -60016:
                if ((_j = error === null || error === void 0 ? void 0 : error.data) === null || _j === void 0 ? void 0 : _j.max_leverage) {
                    localizedError = $st("over_max_leverage", { leverage: (_k = error === null || error === void 0 ? void 0 : error.data) === null || _k === void 0 ? void 0 : _k.max_leverage });
                }
                break;
            case -99003:
                if (error && error.data && error.data.bu_order_data && error.data.bu_order_data.investment) {
                    const arr = error.data.bu_order_data.investment;
                    if (arr.length) {
                        localizedError = arr[0] || "";
                    }
                }
                break;
            case 40020999:
                localizedError = $st("trade_error_symbol_is_banned");
                break;
            case 40020300:
                localizedError = $st("trade_error_price_filter_denied");
                break;
            case 40300300:
                localizedError = $st("trade_error_leveraged_coin_price_low");
                break;
            case 40300500:
                if (error && error.data && error.data.limit && error.data.quote) {
                    localizedError = $st("trade_error_market_spending_more", {
                        limit: `${error.data.limit} ${error.data.quote}`,
                    });
                }
                break;
            case 40101621: // 时间戳错误
                localizedError = $st("invalid_timestamp_check_time");
                break;
            case 40300600:
            case -50006:
                ///> 禁止下3x杠杆代币手动的订单
                localizedError = $st("trade_error_leveraged_manual_3x_stuck");
                break;
            case -51:
                ///> 禁止下3x杠杆代币bot的订单
                localizedError = $st("trade_error_leveraged_bot_3x_stuck");
                break;
            case -98:
            case -99070:
            case 40300950: {
                // 检测用户kyc或ip地址所在地区杠杆代币被禁止
                const country = exports.ParseErrorUtils.parseRemoteCountryCodeToString((_m = (_l = error.data) === null || _l === void 0 ? void 0 : _l.country) !== null && _m !== void 0 ? _m : "", $st);
                localizedError = $st("leverage_coin_trading_country_disable_desc", {
                    country: country,
                });
                break;
            }
            case 40300940: {
                ///> 40300940国内用户没有绑定邮箱禁止创建手动买入
                localizedError = $st("cannot_create_manual_trade_desc");
                break;
            }
            case -99:
            case -99080: {
                const country = exports.ParseErrorUtils.parseRemoteCountryCodeToString((_p = (_o = error.data) === null || _o === void 0 ? void 0 : _o.country) !== null && _p !== void 0 ? _p : "", $st);
                localizedError = $st("bot_trading_country_disable_desc", {
                    country: country,
                    bot: "",
                });
                // 检测用户kyc或ip地址所在地区机器人被禁止
                break;
            }
            case -99999: {
                localizedError = $st("trade_error_IP_forbidden");
                break;
            }
            default:
                localizedError = exports.ParseErrorUtils.formatterToString(error);
                break;
        }
        return localizedError;
    },
    parseCreateOrderError(orderType, error, base, quote, $st) {
        let errMsg = "";
        let localizedError = "";
        if (error && error.response && error.response.msg) {
            errMsg = error.response.msg;
        }
        else if (error && error.message) {
            errMsg = error.message;
        }
        // BU service error
        localizedError = this.parseTradeError(error, $st);
        if (errMsg.indexOf("INSUFFICIENT_FUNDS") >= 0 ||
            errMsg.indexOf("Insufficient fund") >= 0 ||
            errMsg.indexOf("insufficient balance") >= 0 ||
            errMsg.indexOf("account balance insufficient") >= 0 ||
            errMsg.indexOf("Not enough balance") >= 0) {
            localizedError = TradeErrorConstants_1.TradeErrorConstants.insufficientBalance($st);
        }
        else if (errMsg.indexOf("MIN_TRADE_REQUIREMENT_NOT_MET") >= 0 ||
            errMsg.indexOf("Invalid quantity") >= 0 ||
            errMsg.indexOf("Quantity not a valid number") >= 0 ||
            errMsg.indexOf("Quantity too low") >= 0 ||
            errMsg.indexOf("MIN_NOTIONAL") >= 0 ||
            errMsg.indexOf("less than the min limit order") >= 0) {
            localizedError = TradeErrorConstants_1.TradeErrorConstants.lessThanMinQuantity($st);
        }
        else if (errMsg.toLowerCase().indexOf("network request failed") >= 0) {
            localizedError = TradeErrorConstants_1.TradeErrorConstants.networkError($st);
        }
        else if (error.response &&
            error.response.reason &&
            error.response.code &&
            error.response.reason.indexOf("create failed low") >= 0) {
            // 小于最小成交单位或者价格小于最小成交价
            if (error.response.code === TradeAPILib_1.CreateOrderFailedReason.lowAmount) {
                localizedError = TradeErrorConstants_1.TradeErrorConstants.lowAmount(`${error.response.msg} ${base}`, $st);
            }
            else if (error.response.code === TradeAPILib_1.CreateOrderFailedReason.lowPrice) {
                localizedError = TradeErrorConstants_1.TradeErrorConstants.priceTooLow(error.response.msg, $st);
            }
            else if (error.response.code === TradeAPILib_1.CreateOrderFailedReason.lowQuoteAmount) {
                localizedError = TradeErrorConstants_1.TradeErrorConstants.lowCost(`${error.response.msg} ${quote}`, $st);
            }
        }
        if (!localizedError) {
            if (orderType === TradeAPILib_1.ExchangeOrderType.gridFuture) {
                localizedError = $st("lib_ui_future_create_unknown_error");
            }
            else {
                const msg = errMsg || JSON.stringify(error) || `${error}` || "unknow";
                localizedError = TradeErrorConstants_1.TradeErrorConstants.unknownError("-1", msg, $st);
            }
        }
        return localizedError;
    },
    queryOrderErrorMessageLocal(orderType, state, msg, $st) {
        // 前端手动加上前缀
        const prefix = "BOT_ORDER_CLOSED_REASON_";
        // 云配的Key
        const code = prefix + (msg === null || msg === void 0 ? void 0 : msg.toUpperCase());
        // 标准化错误
        const error = {
            code,
            message: code,
        };
        const localErr = (0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error);
        // 如果云端没找到错误码，返回未知错误
        const result = localErr.message === code ? $st("order_status_error_normal") : localErr.message;
        // 合约波段机器人订单
        const isSmartTrade = orderType === TradeAPILib_1.ExchangeOrderType.futures_smart_trade;
        if (state === TradeAPILib_1.ExchangeOrderStatus.canceling) {
            // 正在取消
            return $st("order_status_canceling");
        }
        else if (state === TradeAPILib_1.ExchangeOrderStatus.canceled) {
            // 已取消
            if (supportParseErrorOrders.includes(orderType)) {
                return msg === undefined ? $st("order_status_traded") : result;
            }
            return isSmartTrade ? result : $st("order_status_canceled");
        }
        // 其他状态
        return $st("order_status_traded");
    },
    /**
     * 订单初步错误解析，错误弹框之前的展示
     * @param orderType
     * @param state
     * @param msg
     */
    queryOrderErrorMessage(orderType, state, msg) {
        let content;
        if (supportParseErrorOrders.some((a) => a === orderType)) {
            if (state === TradeAPILib_1.ExchangeOrderStatus.canceling) {
                content = "order_status_canceling";
            }
            else if (state === TradeAPILib_1.ExchangeOrderStatus.canceled) {
                switch (msg) {
                    case "user_cancel":
                    case "canceled": {
                        content = "order_msg_user_cancel";
                        break;
                    }
                    case "profit_stop": {
                        content = "order_msg_profit_stop";
                        break;
                    }
                    case "loss_stop": {
                        content = "order_msg_loss_stop";
                        break;
                    }
                    case "force_liquidation": {
                        content = "future_order_liquidated";
                        break;
                    }
                    case "auto_close": {
                        content = "order_status_auto_close";
                        break;
                    }
                    case "not_enough_loan_market": {
                        content = "order_canceled_by_not_enough_loan_market";
                        break;
                    }
                    case "leveraged_token_split": {
                        content = "order_canceled_by_leveraged_merge_title";
                        break;
                    }
                    case "admin_cancel": {
                        content = "order_canceled_by_admin_cancel_title";
                        break;
                    }
                    case "follow_kol": {
                        content = "order_status_follow_close";
                        break;
                    }
                    case "symbol_offline": {
                        content = "order_status_symbol_offline";
                        break;
                    }
                    case undefined: {
                        content = "order_status_traded";
                        break;
                    }
                    default: {
                        content = "order_status_error_appear";
                        break;
                    }
                }
            }
            else {
                content = "order_status_traded";
            }
        }
        else if (orderType === TradeAPILib_1.ExchangeOrderType.futures_smart_trade) {
            if (state === TradeAPILib_1.ExchangeOrderStatus.canceling) {
                content = "order_status_canceling";
            }
            else if (state === TradeAPILib_1.ExchangeOrderStatus.canceled) {
                switch (msg) {
                    case "TAKEOVER": {
                        content = "future_smart_trade_close_position_takeover";
                        break;
                    }
                    case "MANUAL": {
                        content = "future_smart_trade_close_position_manual";
                        break;
                    }
                    case "ADMIN": {
                        content = "future_smart_trade_close_position_admin";
                        break;
                    }
                    case "TRAIL": {
                        content = "title_track_order";
                        break;
                    }
                    default: {
                        content = "order_status_error_appear";
                        break;
                    }
                }
            }
            else {
                content = "order_status_traded";
            }
        }
        else {
            if (state === TradeAPILib_1.ExchangeOrderStatus.canceling) {
                content = "order_status_canceling";
            }
            else if (state === TradeAPILib_1.ExchangeOrderStatus.canceled) {
                content = "order_status_canceled";
            }
            else if (state === TradeAPILib_1.ExchangeOrderStatus.filled) {
                content = "order_status_traded";
            }
            else {
                content = "order_status_traded";
            }
        }
        return content;
    },
    /**
     * 追加保证金，提取利润 ，加仓 解析错误提示 ,该解析为发起上述动作返回的错误解析
     * 示例：{
    "code": -30004,
    "message": "invalid amount",
    "data": {
        "max_amount": 167.9197174589420500000000000,
        "unexpected_amount": 200.00000000
    }
}
     * @param transfer_type
     * @param error
     * @param $st
     * @param direction transfer_type 为TransferType.investment 时，必填
     */
    getTransferErrorMessage(transfer_type, error, $st, direction) {
        var _a;
        switch (error.code) {
            case -20002:
                if (transfer_type === TradeAPILib_1.TransferType.profit) {
                    return $st("transfer_profit_error_20002");
                }
                if (transfer_type === TradeAPILib_1.TransferType.investment) {
                    if (direction === "in") {
                        return $st("fsa_order_add_position_20002");
                    }
                    if (direction === "out") {
                        return $st("fsa_order_reduce_position_20002");
                    }
                }
                return $st("grid_err_error_manual") + error.message;
            case -30002:
                return $st("transfer_profit_error_30002");
            case -30003:
                return $st("transfer_profit_error_30003");
            case -30004:
                const maxCount = (_a = error.data) === null || _a === void 0 ? void 0 : _a.max_amount;
                if (maxCount !== undefined) {
                    if (transfer_type === TradeAPILib_1.TransferType.investment) {
                        if (direction === "in") {
                            return $st("fsa_order_add_position_max", {
                                max: maxCount,
                                quote: "USDT",
                            });
                        }
                        if (direction === "out") {
                            return $st("sr_order_reduce_position_max", {
                                max: maxCount,
                                quote: "USDT",
                            });
                        }
                    }
                    return $st("transfer_profit_error_30004");
                }
                else {
                    return $st("transfer_profit_error_30004");
                }
            default:
                const parseCommonError = this.parseTradeError(error, $st);
                if (parseCommonError) {
                    return parseCommonError;
                }
                else {
                    return $st("grid_err_error_manual") + error.message;
                }
        }
    },
    /**
     * 追加保证金，提取利润 ，加仓 解析错误提示 ,该解析为查询上述动作返回的错误解析
     * 示例：{
            "direction": "in",
            "type": "investment",
            "transfer_id": "53fd9b16-824a-4653-8cf7-164f75cad41e",
            "bu_order_id": "03da5b94-3954-4237-962d-e21235f67899",
            "coin": "USDT",
            "amount": "12",
            "status": "success",
            "error": null,
            "create_time": 1628253080776,
            "update_time": 1628253087449
        }
     * @param transferType
     * @param error
     * @param $st
     * @param direction
     */
    queryFsaOperationError(transferType, error, $st, direction) {
        switch (error) {
            case "invalid_amount": {
                return $st("transfer_profit_error_30004");
            }
            case "too_much_amount": {
                if (transferType === TradeAPILib_1.TransferType.margin) {
                    return $st("Error_too_much_amount_margin_withDrawn");
                }
                if (transferType === TradeAPILib_1.TransferType.profit) {
                    return $st("Error_too_much_amount_profit_withDrawn");
                }
                return $st("Error_too_much_amount_common");
            }
            case "not_enough_balance": {
                if (transferType === TradeAPILib_1.TransferType.margin) {
                    return $st("Error_not_enough_balance_add_margin");
                }
                if (transferType === TradeAPILib_1.TransferType.investment) {
                    return $st("Error_not_enough_balance_add_position");
                }
                return $st("not_enough_balance");
            }
            case "insufficient_funds": {
                return $st("error_insufficient_funds");
            }
            default: {
                return error;
            }
        }
    },
    /**
     *  订单错误解析，错误弹框之前的标题
     * @param msg
     * @param $st
     */
    translateGridErrMsgTitle(msg, $st) {
        switch (msg) {
            case "leveraged_token_split":
                return $st("order_error_leveraged_merge_title_occur");
            case "admin_cancel":
                return $st("order_canceled_by_admin_cancel_title");
            case "TAKEOVER":
                return $st("order_canceled_by_takeover_title");
            case "symbol_offline":
                return $st("order_status_symbol_offline");
            default:
                return $st("order_status_error_normal");
        }
    },
    /**
     * 订单错误解析，错误弹框之后的展示
     * @param status
     * @param base
     * @param quote
     * @param $st
     */
    translateGridErrMsgInfo(status, base, quote, $st) {
        switch (status) {
            case "error_balance_not_enough_quote": {
                return $st("grid_err_error_balance_not_enough_quote", { quote: quote });
            }
            case "error_balance_not_enough_base": {
                return $st("grid_err_error_balance_not_enough_base", { base: base });
            }
            case "error_balance_not_enough_both_side": {
                return $st("grid_err_error_balance_not_enough_both_side", {
                    base: base,
                    quote: quote,
                });
            }
            case "Error_to_get_balance":
            case "error_in_get_balance": {
                return $st("grid_err_error_in_get_balance");
            }
            case "error_in_place_grid_balance_order": {
                return $st("grid_err_error_in_place_grid_balance_order");
            }
            case "error_in_wait_sell_grid_balance": {
                return $st("grid_err_error_in_wait_sell_grid_balance");
            }
            case "error_in_grid_stop_loss": {
                return $st("grid_err_error_in_grid_stop_loss");
            }
            case "error_in_cancel_orders": {
                return $st("grid_err_error_in_cancel_orders");
            }
            case "error_in_place_grid_orders": {
                return $st("grid_err_error_in_place_grid_orders");
            }
            case "error_in_wait_order_done": {
                return $st("grid_err_error_in_wait_order_done");
            }
            case "error_none_balances_got": {
                return $st("grid_err_error_none_balances_got");
            }
            case "error_got_none_check_grids": {
                return $st("grid_err_error_got_none_check_grids");
            }
            case "error_not_found_cross_order": {
                return $st("grid_err_error_not_found_cross_order");
            }
            case "error_got_none_cb_info": {
                return $st("grid_err_error_got_none_cb_info");
            }
            case "error_got_unknown_cb_action": {
                return $st("grid_err_error_got_unknown_cb_action");
            }
            case "error_add_not_balanced_monitor_error": {
                return $st("grid_err_error_add_not_balanced_monitor_error");
            }
            case "error_add_balanced_monitor_error": {
                return $st("grid_err_error_add_balanced_monitor_error");
            }
            case "error_stop_in_loss": {
                return $st("grid_err_error_stop_in_loss");
            }
            case "error_balance_not_enough_in_run_time": {
                return $st("grid_err_error_balance_not_enough_in_run_time");
            }
            case "error_got_unknown_order_id": {
                return $st("grid_err_error_got_unknown_order_id");
            }
            case "loss_stop": {
                return $st("grid_pro_loss_stop");
            }
            case "profit_stop": {
                return $st("grid_pro_profit_stop");
            }
            case "error": {
                return $st("gridPro_err_error");
            }
            case "force_liquidation": {
                return $st("gridPro_err_force_liquidation");
            }
            case "INSUFFICIENT_FUNDS":
                return $st("INSUFFICIENT_FUNDS_ERROR");
            case "not_enough_balance": {
                return $st("not_enough_balance");
            }
            case "not_enough_balance_when_lock": {
                // 下单后锁资金时资金不足，自动关单.
                return $st("not_enough_balance_when_lock");
            }
            case "AUTHENTICATION_ERROR":
            case "invalid_api_key": {
                return $st("invalid_api_key");
            }
            case "per_volume_hit_amount_min": {
                return $st("per_volume_hit_amount_min");
            }
            case "cannot_reach_limit_open_price": {
                return $st("cannot_reach_limit_open_price");
            }
            case "ORDER_BOOK_INVALID":
            case "no_orderbook": {
                return $st("no_orderbook");
            }
            case "invalid_margin_type": {
                return $st("invalid_margin_type");
            }
            case "invalid_position_side": {
                return $st("invalid_position_side");
            }
            case "position_not_matched": {
                return $st("position_not_matched");
            }
            case "leverage_not_matched": {
                return $st("leverage_not_matched");
            }
            case "has_position_before_open": {
                return $st("has_position_before_open");
            }
            case "has_open_orders_before_open": {
                return $st("has_open_orders_before_open");
            }
            case "not_managed_exchange_order": {
                return $st("not_managed_exchange_order");
            }
            case "grid_profit_rate_less_than_fee_rate": {
                return $st("grid_profit_rate_less_than_fee_rate");
            }
            case "Error_exchange_order_canceled":
            case "exchange_order_canceled_by_user": {
                return $st("exchange_order_canceled_by_user");
            }
            case "Error_to_create_buy_order": {
                return $st("error_to_create_buy_order");
            }
            case "Error_to_create_sell_order": {
                return $st("error_to_create_sell_order");
            }
            case "Error_to_get_order":
            case "error_in_get_my_trades": {
                return $st("error_in_get_my_trades");
            }
            case "Error_insufficient_base_amount": {
                return $st("Error_insufficient_base_amount", { base: base });
            }
            case "Error_insufficient_quote_amount": {
                return $st("Error_insufficient_quote_amount", { quote: quote });
            }
            case "Error_failed_to_lock_amount": {
                return $st("Error_failed_to_lock_amount");
            }
            case "CREATE_STRATEGY_FAILED":
            case "Error_failed_to_create_strategy": {
                return $st("Error_failed_to_create_strategy");
            }
            case "Error_failed_to_clear_strategy": {
                return $st("Error_failed_to_clear_strategy");
            }
            case "STRATEGY_ALLOCATE_FAILED":
            case "Error_failed_to_allocate_strategy": {
                return $st("Error_failed_to_allocate_strategy");
            }
            case "Error_failed_to_unlock_amount": {
                return $st("Error_failed_to_unlock_amount");
            }
            case "RPC_ERROR":
            case "Error_invalid_rpc_response": {
                return $st("Error_invalid_rpc_response");
            }
            case "BAD_BALANCE_ORDER": {
                return $st("ERROR_BAD_BALANCE_ORDER");
            }
            case "OUT_OF_BOUNDS_ERROR": {
                return $st("ERROR_OUT_OF_BOUNDS_ERROR");
            }
            case "error_in_create_order":
            case "CREATE_EXCHANGE_ORDER_FAILED": {
                return $st("ERROR_CREATE_EXCHANGE_ORDER_FAILED");
            }
            case "CANCEL_EXCHANGE_ORDER_FAILED": {
                return $st("ERROR_CANCEL_EXCHANGE_ORDER_FAILED");
            }
            case "EXCHANGE_ORDER_STATUS_ERROR": {
                return $st("ERROR_EXCHANGE_ORDER_STATUS_ERROR");
            }
            case "ADJUST_ORDER_FAILED": {
                return $st("ERROR_ADJUST_ORDER_FAILED");
            }
            case "admin_cancel": {
                return $st("Error_admin_cancel_1");
            }
            case "transfer_error": {
                return $st("Error_transfer_error");
            }
            case "auto_close": {
                return $st("fsa_order_auto_close");
            }
            case "invalid_argument": {
                return $st("Error_invalid_argument");
            }
            case "not_enough_loan_market": {
                return $st("error_not_enough_loan_market");
            }
            case "no_position": {
                return $st("fsa_error_no_position");
            }
            case "invalid_trial_fund_param": {
                return $st("error_invalid_trial_fund_param");
            }
            case "leveraged_token_split": {
                return $st("order_canceled_by_leveraged_merge_desc");
            }
            case "order_min_cost_exception": {
                return $st("error_order_min_cost_exception");
            }
            case "symbol_offline": {
                return $st("grid_futures_symbol_offline_msg");
            }
            default: {
                return $st("order_status_error_normal_content");
            }
        }
    },
    parseRemoteCountryCodeToString(code, $st) {
        switch (code) {
            case "CN":
            case "CHN":
                return $st("chinese_mainland");
            case "US":
            case "USA":
                return $st("united_states");
            default:
                return code;
        }
    },
    queryFMOperationError(error, $st, tradeype) {
        switch (error.code) {
            case 40020300:
                return $st("fm_arbitrage_error_40020300");
            case 40021102:
                if (tradeype === "Invest") {
                    return $st("fm_arbitrage_invest_error_40021102");
                }
                else if (tradeype === "Redeem") {
                    return $st("fm_arbitrage_redeem_error_40021102");
                }
                return $st("fm_arbitrage_profit_error_40021102");
            case 40021103:
                if (tradeype === "Invest") {
                    return $st("fm_arbitrage_invest_error_40021103");
                }
                return $st("fm_arbitrage_redeem_error_40021103");
            case 40020901:
                return $st("fm_arbitrage_error_40020901");
            case 50020299:
                return $st("fm_arbitrage_error_50020299");
            case 40300991: {
                return $st("fm_arbitrage_error_40300991");
            }
            default:
                return $st("grid_err_error_manual") + error.message;
        }
    },
    /**
     *  订单取消，error 解析
     * @param error
     * @param $st
     */
    parseOrderCancelError(error, $st) {
        if (error.code === -8) {
            return $st("bot_order_cancel_fail_by_order_canceled_already");
        }
        else if (error.code === -50004 || error.code === -50005) {
            const baseDisplay = TradeAPILib_1.TradeUtils.parseDisplay(error.data.base, error.data.quote, TradeAPILib_1.ExchangeID.PIONEXV2).baseDisplay;
            return $st("fsa_cancel_error_50", {
                symbol: `${baseDisplay}/${error.data.quote}`,
            });
        }
        else if (error.code === -50008) {
            return $st("bot_cancel_error_50008");
        }
        else {
            return error.message;
        }
    },
};
